
var ScheduleCtrl = function ($scope, $q, previousState, $log, SettingsConstants, $state, dealerModelService, customerModelService, $filter, errorRouterService, errorScreenService, ERR, apiService, transportationOptionsService) {
    Object.defineProperty($scope, 'pickupAddress', {
        enumerable: false,
        configurable: false,
        set: function (value) {
            customerModelService.setTransportationPickupAddress(value);
        },
        get: function () {
            return customerModelService.getTransportationPickupAddress();
        }
    });

    Object.defineProperty($scope, 'deliveryAddress', {
        enumerable: false,
        configurable: false,
        set: function (value) {
            customerModelService.setTransportationDeliveryAddress(value);
        },
        get: function () {
            return customerModelService.getTransportationDeliveryAddress();
        }
    });


    // this variables stores all listeners to the http error to have
    // possibility to unsubscribe when scope destroy event calls
    var httpErrorsListeners = [];

    // this varible stores all listeners related to custom error handlers
    // to have possibility to unsubscribe when scope destroy event calls
    var customErrorListeners = [];

    var opCodes = customerModelService.getOpCodes();
    var confirmationCode = customerModelService.getConfirmationCode();

    // listen for the all http errors related to the getTransportationOptions
    // method
    httpErrorsListeners.push(errorRouterService.subscribe(function () {
        //in case if transportation options request fails we init
        //local model as an empty array and selected transportation
        //option as null api should attach required transportation
        //option for the current appointment withiout any actions
        //from client side logic.
        $scope.transportationOptions = [];
        $scope.selectedTransportationOption = null;
        //do not call global error interceptor logic
        return $q.when(true);
    }, {resourceName: 'getTransportationOptions', status: '*'}));

    // listen for the all http errors related to the getAdvisers
    // method
    httpErrorsListeners.push(errorRouterService.subscribe(function () {
        //ToDo: in case if required to process this error in special way instead of
        //generic error write your code here and return $q.when(true) - this result
        //will prevent call of the generic error and will give you opportunity to
        //process this error not in typical way.
        return $q.when(false);
    }, {resourceName: 'getAdvisers', status: '*'}));

    // listen for the all http errors related to the getAvailableTime
    // method
    httpErrorsListeners.push(errorRouterService.subscribe(onGetAvaliableTimeHttpError, {
        resourceName: 'getAvailableTime',
        status: '*'
    }));

    // listen for the all http errors related to the getDepartment
    // method
    httpErrorsListeners.push(errorRouterService.subscribe(onGetAvaliableTimeHttpError, {
        resourceName: 'getDepartment',
        status: '*'
    }));

    // subscribe handler for the custom errors processing
    errorScreenService.subscribe(onCustomError);

    //process http error related to the avaliable time retrieving functionality
    function onGetAvaliableTimeHttpError() {
        invokeGetAvaliableTimeError(true);
        return $q.when(true);
    };

    //trigger GetAvaliableTimeError screen
    function invokeGetAvaliableTimeError(error) {
        errorScreenService.error(error, ERR.CAN_NOT_GET_AVALIABLE_TIME, {
            noFullScreen: true,
            template: 'template/errorscreens/can-not-get-avaliable-time',
            errorType: ERR.CAN_NOT_GET_AVALIABLE_TIME
        });
    };

    //process custom errors
    function onCustomError(show, id) {
        switch (id) {
            case ERR.CAN_NOT_GET_AVALIABLE_TIME:
                $scope.hideCalendar = show;
                break;
            default:
                break;
        }
    };

    //unsubscribe all http exception listeners
    $scope.$on('$destroy', function () {
        httpErrorsListeners.forEach(function (id) {
            errorRouterService.unsubscribe(id);
        });
        customErrorListeners.forEach(function (id) {
            errorScreenService.unsubscribe(id);
        });
    });

    function setTransportationOptions(options) {

        var deferred = $q.defer();

        var vehicle = customerModelService.getCurrentVehicle();

        // get vehicle link
        var vehicleHref = _.get(_.find(_.get(vehicle, 'links'),
            function (link) {
                return link.rel == 'self' || link.rel == 'http://api.dealer-fx.com/docs/rels/vehicle';
            }), 'href');

        //get selected customer services
        var services = customerModelService.getSelectedMaintenanceServices();

        apiService.getCatalog()
            .then(function (catalog) {
                return catalog.getAppointmentSummary({
                    services: _.flatMap(services),
                    vehicle: {links: [{rel: 'http://api.dealer-fx.com/docs/rels/vehicle', href: vehicleHref}]},
                    mileage: 0
                });
            })
            .then(function (data) {
                // modify TransprtationOptions based on PU/D Wagoneer logic
                var wagoneerTransportationOptions = transportationOptionsService.handleWagoneerTO(options, customerModelService.isPickupAndDeliveryWagoneerModel());
                var isPUDDeleted = false;

                if (wagoneerTransportationOptions.length !== options.length) {
                    options = wagoneerTransportationOptions;
                    isPUDDeleted = true;
                }

                var totalLabourHours = data.totalLabourHours;
                var transportationOptions = options.map(function (el, index) {
                    transportationOptionsService.handleTO(el, customerModelService.isGMDealer(), customerModelService.isCadillacMake());
                    var slot = _.find($scope.selectedTime.slots, function (s) {
                        return el.code == _.replace(s.name, 'urn:dfx:transportation-options:', '');
                    });
                    var labourHours = el.minHours ? el.minHours : 0;
                    var enabled = slot ? (slot.name.indexOf('own-ride') > 0 || !!slot.count) && totalLabourHours >= labourHours : false;
                    return angular.extend(el, {
                        index: index,
                        enabled: enabled
                    });
                });
                //when customer visits schedule page first time we have to preselect default
                //transportation option. Default transportation option is 'own-ride'
                //option in transportation options collection. In case when transportation
                //options reloads due to current schedule date changing or previosly set by
                //the existing appointment initialization process we should check if
                //selected transportation option is still avaliable to do this we will use
                //value from the collection that has got by the API request

                // NOTE: if IsPickupAndDeliveryWagoneerOnlyEnabled is true, a bug can occur
                // when a customer selects PU/D on Schedule page with an eligible model,
                // but then goes back and changes vehicle to a non eligible model.
                // This causes the "Schedule__Transportation_Not_Available" message to be displayed
                // without a transportation option name to complete it, as PU/D no longer exists.
                // FIX: (referring to isPUDDeleted case): preselect 'own-ride' if the above situation occurs to
                // prevent the message from displaying

                if (!$scope.selectedTransportationOption) {
                    $scope.selectedTransportationOption = customerModelService.setCurrentTransportationOption(_.find(transportationOptions, {'code': 'own-ride'}), false);
                } else if (isPUDDeleted && $scope.selectedTransportationOption.code === 'need-pickup') { // Refer to NOTE above
                    $scope.selectedTransportationOption = customerModelService.setCurrentTransportationOption(_.find(transportationOptions, {'code': 'own-ride'}), false);
                } else {
                    $scope.selectedTransportationOption = customerModelService.setCurrentTransportationOption(_.find(transportationOptions, {'code': $scope.selectedTransportationOption.code}), false);
                }
                $scope.transportationOptions = transportationOptions;
                isDeliveryRequired($scope.selectedTransportationOption);
                deferred.resolve(options);
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;

    };


    function getTransportationOptions() {
        if ($scope.transportationOptions.length) {
            setTransportationOptions($scope.transportationOptions)
            return;
        }

        var deferred = $q.defer();
        dealerModelService.resolveDepartment(_.flatMap(customerModelService.getSelectedMaintenanceServices())).then(function (d) {
            return d.getTransportationOptions();
        }).then(function (options) {
            return setTransportationOptions(options);
        }).then(function (options) {
            deferred.resolve(options);
        }).catch(function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    };

    function initWeekData() {
        //set the current selected time
        $scope.selectedTime = processTimeSegment(customerModelService.getCurrentScheduledTime());
        //init start week
        $scope.startWeek = 0;
        if ($scope.selectedTime && $scope.selectedTime.day) {
            var selectedDay = moment($scope.selectedTime.day);
            var currentDay = moment().startOf('day');
            if (selectedDay >= currentDay) {
                $scope.startWeek = parseInt(selectedDay.diff(currentDay, 'weeks', true));
            }
        }

        $scope.startDate = moment().add($scope.startWeek * 7, 'days');
        $scope.endDate = moment($scope.startDate).add(6, 'days');
    }

    //init
    //
    //@description
    //Entry point into controller client logic
    function init() {
        //init data arrays for continuos filling to display as a fields for selection
        //on the view

        $scope.hideCalendar = true;
        $scope.transportationOptions = [];
        $scope.availableTimes = [];
        $scope.advisers = [];
        //set the current service adviser
        $scope.adviser = customerModelService.getCurrentAdviser();
        //set the current transportation option
        $scope.selectedTransportationOption = customerModelService.getCurrentTransportationOption();
        //ensure time slots display correct availability
        if ($scope.selectedTransportationOption)
            updateTsAvailability($scope.selectedTransportationOption);
        /// TODO сделать определение свободноего времени
        //initWeekData();
        //avaliablePeriods
        //
        //@description
        //Array of the available periods to filter data in calendar of available time
        //segments. Every element of this array is an object with next fields:
        // - name {string} name of the period
        // - begin {string} time in ISO_8601 format of the begining of the period
        $scope.availablePeriods = [{
            name: 'Morning',
            beginTime: '00:00:00',
            endTime: '11:59:59'
        }, {
            name: 'Afternoon',
            beginTime: '12:00:00',
            endTime: '17:59:59'
        }, {
            name: 'Evening',
            beginTime: '18:00:00',
            endTime: '23:59:59'
        }];
        //set the current selected period. By default it is undefined and we show user all
        //available time segments in calendar
        $scope.selectedPeriod = undefined;
        //resolve required data from the server
        // dealerModelService.resolveDealer(customerModelService.getSelectedMaintenanceServices())

        $scope.bookAppoimentServicesLoader.addPromise(customerModelService.resolveDealerMainManufacturer());
        $scope.bookAppoimentServicesLoader.addPromise(
            dealerModelService.resolveDealer()
                .then(function (dealer) {
                    $scope.currentDealer = dealer;
                    initWeekData();
                    //get advisers
                    return dealerModelService.getAdvisers(_.flatMap(customerModelService.getSelectedMaintenanceServices()))
                        .then(function (advisers) {
                            $scope.advisers = advisers;
                            //ToDo check on function is needed only for redirect from booked appointment.
                            //Remove this code case in future
                            if ($scope.adviser && customerModelService.getCurrentAppointment()) {
                                // check out whether advisor from appointment in the list
                                if (advisers.filter(function (e) {
                                    return e.id == $scope.adviser.id
                                }).length == 0) {
                                    $scope.advisers.push($scope.adviser);
                                }
                                return $scope.selectAdviser($scope.adviser);
                            } else {
                                //if there is only one adviser in list - force selection of this adviser
                                if ($scope.advisers.length == 1) {
                                    return $scope.selectAdviser($scope.advisers[0]);
                                } else {
                                    return $scope.selectAdviser(_.find(advisers, function (o) {
                                        return o.id == _.get($scope.adviser, 'id')
                                    }));
                                }
                            }
                        });
                }));
    };
    //setCalendarFilter
    //
    //@param {object} selected period element from avaliable periods array
    //
    //@description
    //Set the selected period to select data in timesegments calendar
    $scope.selectPeriod = function (value) {
        $scope.selectedPeriod = value;
        $scope.$broadcast('vertical-srcoll:scroll-to-top');
    };
    //isSelectedPeriod
    //
    //@param {object} element from available periods array
    //
    //@return {boolean} true if passed element is selected by user
    //
    //@description
    //Checks if passed element is selected by user
    $scope.isSelectedPeriod = function (value) {
        return $scope.selectedPeriod == value;
    };
    //formatTime
    //
    //@param {String} date in ISO_8601 format
    //
    //@return {String} time in format HH:MM:SS
    //
    //@description
    //Formats date in ISO_8601 format into HH:MM:SS
    $scope.formatTime = function (value) {
        return moment(value).format('LT');
    };
    //formatDay
    //
    //@param {String} date in ISO_8601 format
    //
    //@return {String} date in format DD MMM
    //
    //@description
    //Formats date in ISO_8601 format into DD MMM
    $scope.formatDay = function (value) {
        return moment(value).format('DD MMM');
    };
    //getWeekDayName
    //
    //@param {String} date in ISO_8601 format
    //
    //@return {String} get week day name
    //
    //@description
    //Get week day name from passed date in ISO_8601 format
    $scope.getWeekDayName = function (value) {
        return moment(value).format('dd');
    };

    $scope.isSelectedTransportationOption = function (transportationOption) {
        //ToDo: wrong way to assess if values is equal by code.
        return $scope.selectedTransportationOption.enabled && $scope.selectedTransportationOption.code == transportationOption.code;
    };

    $scope.isDisabledTransportationOption = function (transportationOption) {
        return !transportationOption.enabled;
    };

    $scope.selectTransportationOption = function (transportationOption) {
        if (!transportationOption.enabled) return;
        $scope.selectedTransportationOption = customerModelService.setCurrentTransportationOption(transportationOption);
        isDeliveryRequired($scope.selectedTransportationOption);
        updateTsAvailability(transportationOption);
    };

    $scope.isSelectedAdviser = function (adviser) {
        //ToDo: wrong way to assess if values is equal.
        return $scope.adviser && $scope.adviser.id == adviser.id;
    };

    $scope.selectAdviser = function (adviser) {
        invokeGetAvaliableTimeError(false);
        var availableTimePromise;

        if (adviser && adviser.getAvailableTime) {
            availableTimePromise = adviser.getAvailableTime($scope.startDate.format('YYYY-MM-DD'), $scope.endDate.format('YYYY-MM-DD'), opCodes, confirmationCode);
        } else {
            availableTimePromise = dealerModelService.resolveDepartment(_.flatMap(customerModelService.getSelectedMaintenanceServices()))
                .then(function (department) {
                    return department.getAvailableTime($scope.startDate.format('YYYY-MM-DD'), $scope.endDate.format('YYYY-MM-DD'), opCodes, confirmationCode);
                });
        }

        if (!$scope.bookAppoimentServicesLoader.isShowed) {
            $scope.availableTimesLoader.addPromise(availableTimePromise);
        }

        return availableTimePromise
            .then(function (data) {

                if (!data.segments || !data.segments.length) {
                    invokeGetAvaliableTimeError(true);
                }
                //susdev-219: add cutoff in the function
                var timesData = processTimeSegments(data.segments);
                var times = timesData.times;


                var needSelectFirstAvailableTime = true;

                var selectAdviser = customerModelService.setCurrentAdviser(adviser === false ? null : adviser);
                $scope.adviser = adviser === false ? false : selectAdviser;
                $scope.availableTimes = times;
                if ($scope.selectedTransportationOption)
                    updateTsAvailability($scope.selectedTransportationOption);

                // Select time according to existing appointment and skip first time that was selected on a initial stage
                var appointment = customerModelService.getCurrentAppointment();
                var foundTime;
                // Set the time according to existing appoinment
                if (appointment && appointment.scheduledTime) {
                    var appointmentAdviserLink = _.find(_.get(appointment, 'links'), {rel: 'http://api.dealer-fx.com/docs/rels/service-advisor'});
                    var currentAdviserLink = _.find(_.get(adviser, 'links'), {rel: 'self'});
                    if (_.get(appointmentAdviserLink, 'href', 1) == _.get(currentAdviserLink, 'href', 2)) {
                        var appointmentTime = processTimeSegment({time: appointment.scheduledTime, available: true});
                        var foundTime = _.find(_.get(times, appointmentTime.day), {time: appointmentTime.time});
                        if (foundTime) {
                            //TODO: PBI-18903 for existing appointment time segment should be unlocked via API
                            // check and disable forced unlock after API fixes.
                            foundTime.original.available = foundTime.available = true;
                            $scope.selectPeriod(findPeriod(foundTime));
                            needSelectFirstAvailableTime = false;
                            return $scope.selectTime(foundTime);
                        }
                    } else if (_.get(appointment.advisor, 'id', 1) == _.get(adviser, 'id', 2)) {
                        var appointmentTime = processTimeSegment({time: appointment.scheduledTime, available: true});
                        var foundTime = _.find(_.get(times, appointmentTime.day), {time: appointmentTime.time});
                        if (foundTime) {
                            foundTime.original.available = foundTime.available = true;
                        }
                    }
                }

                if ($scope.selectedTime) {
                    foundTime = _.find(_.get(times, $scope.selectedTime.day), {
                        time: $scope.selectedTime.time,
                        available: true
                    });
                    if (foundTime) {
                        $scope.selectPeriod(findPeriod(foundTime));
                        needSelectFirstAvailableTime = false;
                        return $scope.selectTime(foundTime);
                    }
                }

                var firstAvailableTime = _.find(_.flatMap(times), {available: true});
                if (firstAvailableTime && needSelectFirstAvailableTime) {
                    firstAvailableTime.firstAvailableTime = true;
                    $scope.selectPeriod(findPeriod(firstAvailableTime));
                    return $scope.selectTime(firstAvailableTime, true);
                } else if (!firstAvailableTime && needSelectFirstAvailableTime) {
                    $scope.selectTime();
                    $scope.selectedDay = null;
                    return true;
                }

                // TODO: finalize as soon coined a sane solution
                // if (!adviser) {
                //     $scope.showNoTimeSlot = !firstAvailableTime;
                // }
            })
    };

    $scope.reloadWeek = function (week) {
        $scope.reloadTimes(moment().add(week * 7, 'days'));
    };

    $scope.reloadTimes = function (startDate) {
        $scope.weekLoader = true;
        $scope.startDate = startDate;
        $scope.endDate = moment(startDate).add(6, 'days');

        var availableTimePromise;

        if ($scope.adviser && $scope.adviser.getAvailableTime) {
            availableTimePromise = $scope.adviser.getAvailableTime($scope.startDate.format('YYYY-MM-DD'), $scope.endDate.format('YYYY-MM-DD'), opCodes, confirmationCode);
        } else {
            availableTimePromise = dealerModelService.resolveDepartment(_.flatMap(customerModelService.getSelectedMaintenanceServices()))
                .then(function (department) {
                    return department.getAvailableTime($scope.startDate.format('YYYY-MM-DD'), $scope.endDate.format('YYYY-MM-DD'), opCodes, confirmationCode);
                });
        }

        return availableTimePromise
            .then(function (data) {
                var timesData = processTimeSegments(data.segments);
                var times = timesData.times;
                $scope.availableTimes = times;
                if ($scope.selectedTransportationOption)
                    updateTsAvailability($scope.selectedTransportationOption);
            })
            .finally(function () {
                $scope.weekLoader = false;
            });
    };

    $scope.getTransportationIcon = function (transportationOption) {
        return '#icon--' + transportationOption.code;
    };

    $scope.selectTime = function (time, tooltip) {
        // In case if the time segment was selected automaticaly on scedule
        // initialization current time segment set to undefined to block
        // folowing to summary page next button and force user select new time
        // segment.
        if (time && time.original && time.original.state === 'blocked-opcode') {
            customerModelService.setCurrentScheduledTime(undefined);
            return;
        };

        $scope.showToolTip = tooltip;
        $scope.selectedTime = time;
        customerModelService.setCurrentScheduledTime((time && time.original) ? time.original : time);
        $scope.$parent && ($scope.$parent.scheduledTime = customerModelService.getCurrentScheduledTime());

        if (time && time.time) {
            var lastSelectedDay = $scope.selectedDay;
            $scope.selectedDay = moment(time.time).startOf('day').toDate();
            return getTransportationOptions();
        }
    };

    $scope.selectDay = function (day) {
        var currentDay = $scope.availableTimes[moment(day).startOf('day').format('YYYY-MM-DD')];
        var segment = _.find(currentDay, function (o) {
            return o.available;
        });
        if (!segment) return false;
        $scope.selectTime(segment);
        $scope.selectPeriod(findPeriod(segment));
        $scope.closeCalendar();
        return true;
    };

    $scope.canSelectDay = function (day) {
        return !!$scope.availableTimes[moment(day).startOf('day').format('YYYY-MM-DD')];
    };

    $scope.isSelectedTime = function (time) {
        return $scope.selectedTime && time && time.time === $scope.selectedTime.time && time.original.state !== 'blocked-opcode';
    };

    $scope.isSelectDay = function (day) {
        var date = new Date(day);
        var dayTime = date.getTime() + date.getTimezoneOffset() * 60 * 1000;
        return $scope.selectedDay && day && dayTime === new Date($scope.selectedDay).getTime();
    };

    $scope.calendar_canChangeNavMonth = function (date) {
        return moment(date).isSameOrAfter(moment(), 'month');
    };

    $scope.calendar_isAvailableLogic = function (date) {
        return moment(date).isSameOrAfter(moment(), 'day');
    };

    $scope.calendar_dateSelected = function (date) {
        if (this.canSelectDay(date)) {
            $scope.selectDay(date);
        }
        else {
            $scope.reloadTimes(moment(date).startOf('week'))
                .then(function () {
                    $scope.selectDay(date);
                });
        }
    };

    $scope.toggleCalendar = function (e) {
        e.stopPropagation();
        $scope.showCalendar = !($scope.showCalendar);
    };

    $scope.closeCalendar = function () {
        $scope.showCalendar = false;
    };

    function processTimeSegments(times) {
        if (times.length == 0) {
            return {times: []}
        }

        var t = _(times)
            .map(function (o) {
                return processTimeSegment(o);
            })
            .groupBy('day')
            .value();

        var days = _.keys(t);
        var slotSize = 30;
        var t1 = _.find(t, function (o) {
            return _.size(o) > 0
        });
        if (t1) slotSize = moment(t1[1].time).diff(moment(t1[0].time), 'minutes');

        var allTimes = _.flatMap(_.flatMap(t), function (o) {
            return moment(o.time);
        });
        var maxDate = _.maxBy(allTimes, function (m) {
            return m.format('x');
        });
        var minDate = _.minBy(allTimes, function (m) {
            return m.format('x');
        });

        var maxDayTime = _.maxBy(allTimes, function (m) {
            return m.hours() * 60 + m.minutes();
        });
        var minDayTime = _.minBy(allTimes, function (m) {
            return m.hours() * 60 + m.minutes();
        });


        var minutesFromStart = minDayTime.hour() * 60 + minDayTime.minutes();
        var startTime = _.min(allTimes);
        var endTime = _.max(allTimes);

        var cols = _.ceil(endTime.diff(startTime, 'days', true));
        var rows = _.ceil(((maxDayTime.hours() * 60 + maxDayTime.minutes()) - (minDayTime.hours() * 60 + minDayTime.minutes())) / slotSize);

        // make default time table
        var stTime = moment(minDate).hours(minDayTime.hours()).minutes(minDayTime.minutes());
        var table = _.times(cols, function (col) {
            var dayMoment = moment(stTime).add(col, 'days');
            // if (_.indexOf(days, dayMoment.format('YYYY-MM-DD')) == -1) return null;
            return _.times(rows + 1, function (row) {
                var m = moment(dayMoment).add(row * slotSize, 'minutes');
                return {
                    hide: true,
                    time: m.format('YYYY-MM-DDTHH:mm:ss'),
                    available: false,
                    day: m.format('YYYY-MM-DD')
                };
            });
        });

        // fill table
        _.forEach(t, function (dayList, key) {
            var day = moment(key, 'YYYY-MM-DD');
            var col = Math.abs(_.ceil(day.diff(stTime, 'days', true)));
            _.forEach(dayList, function (o) {
                var mTime = moment(o.time);
                var tMinutes = mTime.hour() * 60 + mTime.minutes();
                var row = _.floor((tMinutes - minutesFromStart) / slotSize);
                table[col][row] = o;
            });
        });

        // remove null col
        table = _.pull(table, null);
        table = _.keyBy(table, function (o) {
            return _.get(o, '[0].day')
        });

        $scope.isFirstWeek = _.has(table, moment().startOf('day').format('YYYY-MM-DD'));
        $scope.isLastWeek = _.has(table, moment().add(1, 'year').startOf('day').format('YYYY-MM-DD'));

        return {
            times: table,
            minTime: minDate,
            maxTime: maxDate,
            startTime: startTime,
            endTime: endTime,
            slotSize: slotSize,
            days: days
        };
    }

    function processTimeSegment(o) {
        if (!o) return null;
        var m = moment.parseZone(o.time);
        //Add time zone info to fix wrong subtract value
        var eT = moment(moment.parseZone(o.endTime)).subtract($scope.currentDealer.cutOffTime, 'minutes')
            .format('YYYY-MM-DDTHH:mm:ss');
        return {
            original: o,
            day: m.format('YYYY-MM-DD'),
            available: o.available,
            time: m.format('YYYY-MM-DDTHH:mm:ss'),
            slots: o.slots,
            //calculate endTime in controller instead of filter
            endTime: eT
        };
    }

    function updateTsAvailability(transportationOption) {
        _.mapValues($scope.availableTimes, function (times) {
            _.forEach(times, function (time) {
                var slot = _.find(time.slots, function (s) {
                    return transportationOption.code == _.replace(s.name, 'urn:dfx:transportation-options:', '');
                });
                var available = !time.hide && time.original.available && slot && (slot.name.indexOf('own-ride') > 0 || !!slot.count);
                return angular.extend(time, {
                    available: available
                });
            });
        });
    }

    function isDeliveryRequired(transportationOption) {
        $scope.deliveryRequired = !!(transportationOption && transportationOption.code === 'need-pickup');
    }

    function findPeriod(time) {
        if (!time) return null;
        var periods = $scope.availablePeriods;
        for (var i = 0; i < periods.length; i++) {
            if ($filter('calendarFilter')([time], periods[i], 'time').length > 0) return periods[i];
        }
        return null;
    }

    //run the controller
    init();

};
ScheduleCtrl.$inject = ['$scope', '$q', 'previousState', '$log', 'SettingsConstants', '$state', 'dealerModelService', 'customerModelService', '$filter', 'errorRouterService', 'errorScreenService', 'errors', 'apiService', 'transportationOptionsService'];

module.exports = ScheduleCtrl;
